import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  multiFacetCountsFromAlgolia,
  MultiFacetCountsFromAlgoliaParams,
} from "../../../api/postCall/multiFacetCountsFromAlgolia";
import { AlgoliaMultiFacetCountsModel } from "../../../data-model/algoliaMultiFacetCountsModel";

interface AlgoliaMultiFacetsCountState {
  data?: AlgoliaMultiFacetCountsModel;
  loading?: boolean;
  error?: string;
}

const initialState: AlgoliaMultiFacetsCountState = {
  data: undefined,
  loading: false,
  error: undefined,
};

export const algoliaMultiFacetsCountSlice = createSlice({
  name: "algoliaMultiFacetsCount",
  initialState,
  reducers: {
    setAlgoliaMultiFacetsCount: (
      state,
      action: PayloadAction<AlgoliaMultiFacetCountsModel>,
    ) => {
      state.data = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      state.data = undefined;
      state.error = undefined;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.data = undefined;
    },
    resetAlgoliaMultiFacetsCount: (state) => {
      state.data = undefined;
      state.loading = false;
      state.error = undefined;
    },
  },
});

export const {
  setAlgoliaMultiFacetsCount,
  setLoading,
  setError,
  resetAlgoliaMultiFacetsCount,
} = algoliaMultiFacetsCountSlice.actions;

export const fetchMultiFacetsCountFromAlgolia =
  (params: MultiFacetCountsFromAlgoliaParams) =>
  async (dispatch, getState: any) => {
    const { algoliaMultiFacetsCount } = getState();
    if (algoliaMultiFacetsCount.loading) {
      return;
    }
    dispatch(setLoading(true));
    try {
      const response = await multiFacetCountsFromAlgolia(params);
      dispatch(
        setAlgoliaMultiFacetsCount(response as AlgoliaMultiFacetCountsModel),
      );
    } catch (error) {
      dispatch(setError(error as string));
    }
  };

export default algoliaMultiFacetsCountSlice.reducer;
